//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../../funcionales/FormContent";
import MarcoModal from "../../funcionales/MarcoModal";
import FormHeader from "../../funcionales/FormHeader";
import TextButton from "../../buttons/TextButton";
import Loading from "../../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../../functions/dataFunctions";
import {
  submitMovimientoStock,
  submitMovimientoStockDepositos,
} from "../data/Submits";
import { eventos } from "../data/FormContent";
import { crearArticulo, herramientasDelTablero } from "../../../services/stockAlta";
import { rotuloDeArticulo } from "../../../shared/stockDesdeTablero";
//import { refreshCache } from "../../../services/cache";
//------------------------------------------------------ estilos
import "../css/Forms.css";

const FormMovimientoStock = ({ elemento = null, type, onGuardar, onClose }) => {
  const campos = eventos[type];
  const titulo = "Movimiento de Stock";
  const subtitulo = "Altas y bajas manuales";
  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [stock, setStock] = useState([]);
  const [tablero, setTablero] = useState(null);
  /* «Altas y bajas manuales» es donde algo entra por primera vez a un
     depósito, así que es donde tiene que poder nacer el artículo: lo que está
     en el tablero de herramientas se ofrece desde ahí, y lo que no está en
     ningún lado se crea en el momento (Nico, 20/10: «no aparece el artículo
     "guantes de tela" a pesar de que lo agregué a herramientas»). El
     movimiento ENTRE depósitos mueve lo que ya está en uno: ahí no se crea
     nada, y la lista dice dónde se da de alta. */
  const conPuente = type !== "stockDepositos";
  const [formData, setFormData] = useState({
    area: elemento?.area || "administracion",
    deposito: elemento?.deposito || "",
    ingresos: [],
    moneda: elemento?.moneda || "pesos",
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const [data, herr] = await Promise.all([
        cargarSelects(), // trae TODOS los listados, ver si se puede mejorar desp
        conPuente ? herramientasDelTablero() : null,
      ]);
      setListas(data);
      setStock(data["stock"] || []);
      setTablero(herr);
      setLoading(false);
    };

    cargarDatos();
  }, [conPuente]);

  /* El artículo recién creado entra a la lista de este formulario: si se
     agrega dos veces en el mismo movimiento, la segunda ya lo encuentra. */
  const crear = async (borrador) => {
    const r = await crearArticulo(borrador);
    if (r?.ok) {
      const a = r.articulo;
      setStock((prev) => [
        ...prev.filter((o) => String(o.value) !== String(a.id)),
        { value: a.id, label: rotuloDeArticulo(a), raw: a },
      ]);
    }
    return r;
  };

  const listaProps = conPuente
    ? {
        onCrearArticulo: crear,
        herramientas: tablero?.filas || [],
        panoles: tablero?.panoles || {},
        herramientasError: tablero?.error || "",
        deposito: formData.deposito,
        tipos: (listas.stockType || []).map((o) => o.value),
        unidades: (listas.unidades || []).map((o) => o.value),
        sinStockTexto: "Con lo escrito no aparece en Stock.",
      }
    : {
        sinStockTexto:
          "Con lo escrito no aparece en Stock (probá con una parte del nombre). Si es nuevo, primero cargalo en un depósito con MOVIMIENTO (STOCK): ahí se da de alta.",
      };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (type === "stockDepositos") {
      await submitMovimientoStockDepositos(
        elemento,
        formData,
        campos,
        setLoading,
        onGuardar,
        onClose,
      );
    } else {
      await submitMovimientoStock(
        elemento,
        formData,
        campos,
        setLoading,
        onGuardar,
        onClose,
      );
    }
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="doble-form">
          <div className="doble-form-content">
            <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />
            <div className="doble-form-modal">
              <FormContent
                elemento={elemento}
                campos={campos}
                opciones={listas}
                data={formData}
                setData={setFormData}
                listado={stock}
                isDouble={true}
                listaProps={listaProps}
              />
            </div>
            <div className="form-buttons">
              <TextButton
                text={"Guardar"}
                type={"button"}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormMovimientoStock;
